/**
 * Checks if the lexical state contains multiple different font-weight or font-style values.
 * Returns true if either font-weight or font-style has more than one unique value.
 */
export const hasMultipleFontWeightsOrStyles = (lexicalState: string | undefined): boolean => {
  if (!lexicalState) {
    return false;
  }

  const fontWeights = new Set<string>();
  const fontStyles = new Set<string>();
  const textDecorations = new Set<string>();

  // Match all font-weight declarations
  const fontWeightMatches = lexicalState.matchAll(/font-weight:\s*([^;]+)/g);
  for (const match of fontWeightMatches) {
    fontWeights.add(`font-weight: ${match[1].trim()}`);
  }

  // Match all font-style declarations
  const fontStyleMatches = lexicalState.matchAll(/font-style:\s*([^;]+)/g);
  for (const match of fontStyleMatches) {
    fontStyles.add(`font-style: ${match[1].trim()}`);
  }

  const textDecorationMatches = lexicalState.matchAll(/text-decoration:\s*([^;]+)/g);
  for (const match of textDecorationMatches) {
    textDecorations.add(`text-decoration: ${match[1].trim()}`);
  }

  return fontWeights.size > 1 || fontStyles.size > 1 || textDecorations.size > 1;
};
